"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var handleEvent_1 = require("../assets/handleEvent");

var withStyles_1 = require("../decorators/withStyles");

var NativeSelect_styles_1 = require("../Select/NativeSelect.styles");

var Select_1 = __importDefault(require("../Select/Select"));

var LabelPicker_styles_1 = __importDefault(require("./LabelPicker.styles"));

var Progress_1 = __importDefault(require("./Progress"));

var LabelPicker =
/** @class */
function (_super) {
  __extends(LabelPicker, _super);

  function LabelPicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.nativeSelectRef = react_1.default.createRef();
    _this.state = {
      width: null,
      reactSelectOpen: false
    };

    _this.handleChange = function (value) {
      _this.recalculateElementWidth();

      return handleEvent_1.handleEvent(_this.props.onChange, value);
    };

    _this.recalculateElementWidth = function () {
      if (!_this.nativeSelectRef || !_this.nativeSelectRef.current || _this.nativeSelectRef.current.selectedIndex === -1) {
        _this.setState({
          width: null
        });

        return;
      }

      var text = _this.nativeSelectRef.current.options[_this.nativeSelectRef.current.selectedIndex].textContent; // Вычисляем размер текста

      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      context.font = window.getComputedStyle(_this.nativeSelectRef.current, null).getPropertyValue('font');
      var metrics = context.measureText(text);
      var theme = _this.props.theme;
      var borderSize = theme ? theme.sizeBorderWidth : 0;
      var width = metrics.width + NativeSelect_styles_1.nativeSelectPaddingLeft + NativeSelect_styles_1.nativeSelectPaddingRight + borderSize + 1;

      _this.setState({
        width: width
      });
    };

    _this.onOpenReactSelect = function () {
      _this.setState({
        reactSelectOpen: true
      });
    };

    _this.onCloseReactSelect = function () {
      _this.setState({
        reactSelectOpen: false
      });
    };

    return _this;
  }

  LabelPicker.prototype.componentDidMount = function () {
    this.recalculateElementWidth();
  };

  LabelPicker.prototype.render = function () {
    var _a;

    var props = this.props;

    var classes = props.classes,
        onChange = props.onChange,
        progress = props.progress,
        dangerouslyStopAnimation = props.dangerouslyStopAnimation,
        invalid = props.invalid,
        otherProps = __rest(props, ["classes", "onChange", "progress", "dangerouslyStopAnimation", "invalid"]); // корректная работа progress завязана на том что Select-первый потомок


    return react_1.default.createElement("div", {
      className: classnames_1.default(classes.wrapper, (_a = {}, _a[classes.active] = this.state.reactSelectOpen, _a[classes.hideSelect] = progress, _a)),
      style: {
        width: this.state.width
      }
    }, react_1.default.createElement(Select_1.default, __assign({}, otherProps, {
      invalid: invalid,
      onChange: this.handleChange,
      onDidMount: this.recalculateElementWidth,
      nativeSelectOptionRef: this.nativeSelectRef,
      onOpenReactSelect: this.onOpenReactSelect,
      onCloseReactSelect: this.onCloseReactSelect,
      small: true,
      borders: invalid ? 'normal' : 'withoutBorders'
    })), progress && react_1.default.createElement(Progress_1.default, {
      dangerouslyStopAnimation: dangerouslyStopAnimation,
      borders: "withoutBorders"
    }));
  };

  LabelPicker = __decorate([withStyles_1.withStyles(LabelPicker_styles_1.default)], LabelPicker);
  return LabelPicker;
}(react_1.default.Component);

exports.default = LabelPicker;